import { AuthWrapper, Box, Wrapper, Title, Description, BackLink } from "../style";
import { Input } from "shared/components/Input";
import { Button } from "shared/components/Button";
import { useFormik } from "formik";
import * as Yup from 'yup';
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { showNotification } from "shared/redux/slice/notificationSlice";

interface IPropsForgotPasswordForm {
  setIsForgotPassword: (value: boolean) => void;
  setIsConfirm: (value: boolean) => void;
  setLogin: (str: string) => void;
}

interface IPropsRecoveryPassword {
  login: string;
}

export const ForgotPasswordForm = ({ setIsForgotPassword, setIsConfirm, setLogin}: IPropsForgotPasswordForm) => {
  const dispatch = useDispatch();
  
  const mutation = useMutation({
    mutationFn: ({ login }: { login: string }) => {
      return axios.post(`${process.env.API_OAUTH}/v1/user/recovery_password`, {
        login: login
      });
    },
    onError: (error) => {
      throw error
    },
    onSuccess: () => {
      dispatch(showNotification({
        message: "Код для восстановления отправлен!",
        type: "success",
      }));
      setIsConfirm(true);
    }
  })

  const formik = useFormik({
    initialValues: {
      login: '',
    },
    validationSchema: Yup.object({
      login: Yup.string().min(2).required("Логин обязателен!"),
    }),
    onSubmit: (values: IPropsRecoveryPassword, { setSubmitting }) => {
      mutation.mutate({
        login: values.login
      })
      setLogin(values.login)
      setIsConfirm(true);
      setSubmitting(false);
    },
  });

  return (
    <AuthWrapper>
      <Box>
        <Wrapper onSubmit={formik.handleSubmit}>
          <Title>Восстановление пароля</Title>
          <Description>Введите почту или телефон, на который придет ссылка для восстановления пароля</Description>
          <Input
            name="login" 
            onChange={formik.handleChange}
            value={formik.values.login}
            $beforeIcon="userLogin" 
            label="Логин" 
            id="login"
            autoComplete="off"
            placeholder="Введите почту или телефон" 
            type="text" 
            className={(formik.errors.login) ? "error" : ""}
          />
          <Button themeType="primary" type="submit" disabled={!formik.isValid || !formik.dirty}>Отправить</Button>
          <BackLink onClick={() => setIsForgotPassword(false)}>Назад</BackLink>
        </Wrapper>
      </Box>
    </AuthWrapper>
  );
};
